export function addDots(str) {
  if (!str || !str.length) return str;
  if (str.length <= 60) return str;
  if (str.length > 60) return `${str.slice(0, 60)}...`;
}
